import { constant } from 'lodash';
import { GoogleInteractionGroupEvent } from './types';

/* eslint-disable @typescript-eslint/ban-ts-comment */
declare global {
  interface Window {
    dataLayer: any;
  }
}

export const pushGroupEventToDataLayer = (event_name: string, array: any) => {
  if (window?.dataLayer) {
    const pageEvent: GoogleInteractionGroupEvent = {
      event: event_name,
    };

    Object.keys(array).forEach((value) => {
      Object.assign(pageEvent, { [value]: array[value] });
    });

    window.dataLayer.push(pageEvent);
  }
};
